import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../core/providers/data/data.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import {
  MutationAddVehicleArgs,
  MutationSelectVehicleArgs,
  Query,
  QueryVehicleModificationByIdArgs,
  SavedVehicle,
  VehicleModification,
} from '../../../graphql/generated/generated-types';
import { GET_VEHICLE_MODIFICATION_BY_ID } from '../add-vehicle-form/vehicle-modification-by-id.graphql';
import { map, take } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { SelectedModificationService } from '../../services/selected-modification.service';
import { ADD_VEHICLE } from '../add-vehicle-form/add-vehicle.graphql';
import { GET_SAVED_VEHICLES } from '../add-vehicle-form/saved-vehicles.graphql';
import { SELECT_VEHICLE } from '../add-vehicle-form/select-vehicle.graphql';
import { ButtonModule } from 'primeng/button';
import { StateService } from '../../../core/state/old/state.service';
import { Platform } from '@angular/cdk/platform';
import { ActivatedRoute, Router } from '@angular/router';
import { ActiveService } from '../../../core/providers/active/active.service';
import { VehicleType } from '../add-vehicle-form/vehcle-type.interfaces';

export interface ISaveSuggestedVehicleDialogData {
  modificationId: number;
  vehicleType: VehicleType;
}
@Component({
  selector: 'app-save-suggested-vehicle-dialog',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './save-suggested-vehicle-dialog.component.html',
  styleUrl: './save-suggested-vehicle-dialog.component.scss',
})
export class SaveSuggestedVehicleDialogComponent implements OnInit {
  public dialogData: ISaveSuggestedVehicleDialogData;
  public loading: boolean = true;

  public vehicleModification: VehicleModification;
  constructor(
    private dataService: DataService,
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private selectedModificationService: SelectedModificationService,
    private stateService: StateService,
    private platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    private activeService: ActiveService
  ) {
    this.dialogData = this.config.data;
  }

  ngOnInit(): void {
    this.getVehicleModificationById(
      this.dialogData?.modificationId,
      this.dialogData?.vehicleType
    );
  }

  public closeDialog() {
    this.cancelSuggestedVehicle();
  }

  public cancelSuggestedVehicle() {
    if (this.activeService?.activeVehicle) {
      this.stateService.setState(
        'activeVehicleId',
        this.activeService?.activeVehicle?.modificationId
      );
      this.selectedModificationService.setModificationId(
        this.activeService?.activeVehicle?.modificationId
      );
      this.router
        .navigate([], {
          relativeTo: this.route,
          queryParams: {
            modificationId: this.activeService?.activeVehicle?.modificationId,
          },
          queryParamsHandling: 'merge', // keeps existing params
          replaceUrl: true,
        })
        .then(() => {
          this.dialogRef.close(true);
        });
    } else {
      this.stateService.setState('activeVehicleId', null);
      this.selectedModificationService.deleteModificationId();
      this.router
        .navigate([], {
          relativeTo: this.route,
          queryParams: { modificationId: null },
          queryParamsHandling: 'merge', // keeps existing params
          replaceUrl: true,
        })
        .then(() => {
          this.dialogRef.close(true);
        });
    }
  }

  public removeVehicleFromActive() {
    this.setActiveVehicle(); // select vehicle without id so it will unselect active vehicle
  }

  public addVehicleToMySavedList() {
    this.loading = true;
    this.dataService
      .mutate<any, MutationAddVehicleArgs>(ADD_VEHICLE, {
        input: {
          modificationId: this.vehicleModification?.id,
          vehicleType: this.vehicleModification.vehicleType as any,
        },
      })
      .pipe(
        take(1),
        map((data) => data.addVehicle as SavedVehicle)
      )
      .subscribe({
        next: (response: SavedVehicle) => {
          if (response) {
            this.stateService.setState('activeVehicleId', response.id);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
          this.dialogRef.close();
        },
      });
  }

  public getMySavedVehicles() {
    this.dataService
      .query<Query>(GET_SAVED_VEHICLES)
      .pipe(
        map((data: Query) => data.savedVehicles as SavedVehicle[]),
        take(1)
      )
      .subscribe({
        next: (response: SavedVehicle[]) => {},
        error: (error: HttpErrorResponse) => {},
        complete: () => {},
      });
  }

  private setActiveVehicle(vehicleId?: any) {
    this.loading = true;
    this.dataService
      .mutate<any, MutationSelectVehicleArgs>(SELECT_VEHICLE, {
        id: vehicleId,
      })
      .pipe(
        take(1),
        map((data) => data.selectVehicle as SavedVehicle)
      )
      .subscribe({
        next: (response: SavedVehicle) => {
          if (response) {
            this.stateService.setState('activeVehicleId', response.id);
            this.router
              .navigate([], {
                relativeTo: this.route,
                queryParams: { modificationId: response.id },
                queryParamsHandling: 'merge', // keeps existing params
                replaceUrl: true,
              })
              .then(() => {
                this.dialogRef.close(true);
              });
          } else if (!vehicleId && !response) {
            // UNSELECTING ACTIVE VEHICLE

            if (this.activeService?.activeVehicle) {
              this.stateService.setState(
                'activeVehicleId',
                this.activeService?.activeVehicle?.modificationId
              );
              this.selectedModificationService.setModificationId(
                this.activeService?.activeVehicle?.modificationId
              );
              this.router
                .navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    modificationId:
                      this.activeService?.activeVehicle?.modificationId,
                  },
                  queryParamsHandling: 'merge', // keeps existing params
                  replaceUrl: true,
                })
                .then(() => {
                  this.dialogRef.close(true);
                });
            } else {
              this.stateService.setState('activeVehicleId', null);
              this.selectedModificationService.deleteModificationId();
              this.router
                .navigate([], {
                  relativeTo: this.route,
                  queryParams: { modificationId: null },
                  queryParamsHandling: 'merge', // keeps existing params
                  replaceUrl: true,
                })
                .then(() => {
                  this.dialogRef.close(true);
                });
            }
          }
        },
        error: (error) => {
          this.loading = false;
          this.dialogRef.close(true);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  private getVehicleModificationById(
    modificationId: number,
    vehicleType: VehicleType
  ) {
    this.dataService
      .mutate<Query, QueryVehicleModificationByIdArgs>(
        GET_VEHICLE_MODIFICATION_BY_ID,
        {
          input: {
            modificationId: modificationId,
            vehicleType: vehicleType,
          },
        }
      )
      .pipe(
        take(1),
        map((data) => data.vehicleModificationById as VehicleModification)
      )
      .subscribe({
        next: (response: VehicleModification) => {
          console.log(response);
          this.vehicleModification = response;
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }
}
